import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {first} from "rxjs/operators";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {BoosterService} from "../../services/booster.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../../store";
import * as fromStore from "../../../../../store";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";


@Component({
    selector: 'db-test-mode-confirmation',
    templateUrl: './test-mode-confirmation.component.html',
    styleUrls: ['./test-mode-confirmation.component.scss'],
    standalone: false
})
export class TestModeConfirmationComponent implements OnInit {

  @Input() testMode: 'on'|'off'|null;
  @Input() websiteId: number;
  public loading: boolean;

  constructor(
    private _store: Store<DbStoreState>,
    private _activeModal: DbActiveModal,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _boosterService: BoosterService
  ) {}

  ngOnInit() {
    this.resize([302, 700]);
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public close(): void {
    this._activeModal.close();
  }


  public confirm(): void {
    this.loading = true;
    this._boosterService.setTestMode(this.websiteId, this.testMode)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadBoosterData({websiteId: this.websiteId}));
          setTimeout( () => {
            this.loading = false;
            this._activeModal.close();
            NotifierComponent.notify(new Notification("Your test mode is turned on.", NotificationType.SUCCESS));
          }, 4000);
        }
        else {
          this.loading = false;
          this.close();
          NotifierComponent.notify(new Notification(TextUtils.getText('text_somethingWentWrongDot'), NotificationType.DANGER));
        }
      });
  }

  public openKnowledgeBase(): void {
    this._store.dispatch(new fromStore.ToggleKnowledgeBase( {articleId: 7204540443154, scrollToEl: ''}));
    this._activeModal.close();
  }


}
